import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-500 font-medium mb-2" }, " BEETS Price ", -1)
const _hoisted_3 = { class: "text-xl font-medium flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-500 font-medium mb-2" }, " Market Cap ", -1)
const _hoisted_5 = { class: "text-xl font-medium truncate flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "text-sm text-gray-500 font-medium mb-2" }, " Circulating Supply ", -1)
const _hoisted_7 = { class: "text-xl font-medium flex items-end relative" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "text-sm text-gray-500",
  style: { paddingBottom: '2px' }
}, " BEETS ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalLoadingBlock = _resolveComponent("BalLoadingBlock")
  const _component_BalCard = _resolveComponent("BalCard")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, _renderList(3, (n) => {
          return _createVNode(_component_BalLoadingBlock, {
            key: n,
            class: "h-28"
          })
        }), 64))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_BalCard, null, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode("div", _hoisted_3, " $" + _toDisplayString(_ctx.numeral(_ctx.beetsPrice).format('0.[0000]')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_BalCard, null, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode("div", _hoisted_5, " $" + _toDisplayString(_ctx.fNum(_ctx.marketCap, 'usd_lg')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_BalCard, null, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode("div", _hoisted_7, [
                _createVNode("div", null, _toDisplayString(_ctx.fNum(_ctx.circulatingSupply, 'token_lg')) + " ", 1),
                _hoisted_8
              ])
            ]),
            _: 1
          })
        ], 64))
  ]))
}